import createLucideIcon from '../createLucideIcon';

const Info = createLucideIcon('InfoIcon', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['line', { x1: '12', y1: '16', x2: '12', y2: '12', key: 'dkqlv3' }],
  ['line', { x1: '12', y1: '8', x2: '12.01', y2: '8', key: '1kl4hv' }],
]);

export default Info;
